export default __webpack_public_path__ + "static/media/navbar-detailed-dark.c97e4086.svg";